module.exports = __webpack_public_path__ + "static/media/raspberryPiLogo.7defc77b.svg";